import React from "react";

const GoogleMapsAddress = () => {
  return (
    <div className="container text-center" style={{ marginTop: "100px" }}>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          title="Google Maps Address Batiment RS"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d654.0179160282171!2d6.885203194980211!3d49.02824400375354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47944f09ccdbea9f%3A0xfeaed78ce2c61475!2sBatiment%20RS!5e0!3m2!1sfr!2sfr!4v1719346378358!5m2!1sfr!2sfr"
          width="100%"
          height="450"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default GoogleMapsAddress;
